export default function phqNineScoreDescription(number: number): string {
  if (number <= 4) return "pas de dépression";
  if (number <= 9) return "dépression légère";
  if (number <= 14) return "dépression modérée";
  if (number <= 19) return "dépression modérément sévère";
  return "dépression sévère";
}
